import { type ReactElement } from "react";
import { Steps } from "antd";
import { type CurrentStepsProps } from "../../../pages/new-trail/types";

const CurrentSteps = ({ current, items }: CurrentStepsProps): ReactElement => {
  return <Steps size="small" current={current} items={items} />;
};

export default CurrentSteps;
